// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CheckIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from check.svg
 */
export default function CheckIcon(props: CheckIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CheckIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M12.18 2.427a1 1 0 0 1 1.705 1.04l-.066.106-7 10a1 1 0 0 1-1.606.045l-.07-.104-3-5A1 1 0 0 1 3.792 7.39l.065.097 2.207 3.677z"
        />
      </g>
    </svg>
  );
}
